import React, { useState } from "react";

const Header = ({ trekData }) => {
  const [expanded, setExpanded] = useState(false);

  const toggleReadMore = () => setExpanded(!expanded);

  const isLong = trekData.info.length > 300;
  const truncatedInfo = isLong
    ? trekData.info.slice(0, 300) + "..."
    : trekData.info;

  return (
    <div className="w-full max-w-3xl mx-auto px-4 pt-4 sm:px-6">
      {/* Trek Image with title overlay */}
      <div className="relative h-64 w-full overflow-hidden rounded-2xl shadow-lg sm:h-72">
        <img
          src={trekData.image}
          alt={trekData.name}
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-blue-950/95 via-blue-950/70 to-transparent px-5 pb-5 pt-14 sm:px-7 sm:pb-7">
          <h1
            className="!text-2xl font-bold leading-tight tracking-tight !text-white sm:!text-3xl"
            title={trekData.name}
          >
            {trekData.name}
          </h1>
        </div>
      </div>

      {/* Info with expandable text */}
      <div className="mt-4 rounded-2xl border border-sky-100 bg-sky-50/70 p-5 text-base text-slate-700 shadow-sm">
        <span>
          {expanded ? trekData.info : truncatedInfo}
          {isLong && (
            <span
              onClick={toggleReadMore}
              className="ml-1 cursor-pointer font-semibold text-blue-700 hover:text-blue-900"
            >
              {expanded ? "See Less" : "See More"}
            </span>
          )}
        </span>
      </div>
    </div>
  );
};

export default Header;
